<template>
  <div class="task_content">
    <div class="invite">
      <img src="https://static.mingchu.co/webapp/xintan/title_bg1.png" class="title_bg" alt="title">
      <div class="content_padding">
        <div class="content">
          一键分享，邀请助力，火速提升「名厨力」！<br>
          名厨好礼等你来领
        </div>
        <p class="svg_integral fw_bold">名厨App 100 积分</p>
      </div>
      <div class="invite_btn fw_bold" @click="setShareShow">立即分享</div>
    </div>

    <div class="seven_task">
      <img src="https://static.mingchu.co/webapp/xintan/title_bg2.png" class="title_bg" alt="title">
      <div class="content_padding">
        <div class="top_tip">
          <span class="first_span fw_bold" :style="{'opacity': data.is_continuity}">当前已连续挑战</span>
          <span class="second_span">每天00:00 立即刷新任务</span>
        </div>
        <div class="content">
          <div v-if="data.ask_task.question" class="question_content">
            <p>参与名厨问答，增长你的「名厨力」{{ data.ask_task.ask_total }}/3</p>
            <template v-if="data.ask_task.ask_total < 3">
              <div class="question_tip fw_bold">
                Q：{{ data.ask_task.question }}
              </div>
              <van-field
                v-model="questionVal"
                class="question_input"
                rows="4"
                autosize
                type="textarea"
                placeholder="请在此填写您的答案"
              />
              <div class="btn_group">
                <span class="next_btn fw_bold" @click="nextQuestion('next')">跳过 {{ data.ask_task.skip_total }}/3</span>
                <span class="submit_btn fw_bold" @click="nextQuestion()">提交回答</span>
              </div>
            </template>
            <div v-else class="question_finish fw_bold">今日名厨问答已完成 🎉🎉，明天再来吧！</div>
          </div>

          <template v-if="data.user_task.length">
            <p>点击进入餐厅主页，破解杭城美食密码，关注即得「名厨力」加成，首次关注得名厨App 200 积分</p>
            <div class="user_content">
              <div class="user_list">
                <div v-for="user in data.user_task" :key="user.uid" class="list_item" @click="goPath('userview', user.uid)">
                  <div class="user_group">
                    <van-image class="user_pic" lazy-load round :src="user.head_pic_url" />
                    <img v-if="user.auth_icon" :src="user.auth_icon" alt="auth_icon" class="icon_auth">
                  </div>
                  <p class="fw_bold text_overflow">{{ user.nick_name }}</p>
                  <!-- <span :class="{'follow_btn':true, 'active': user.follow_status == 1}"> {{ user.follow_status == 1 ? '已关注' : '关注' }} </span> -->
                </div>
              </div>
            </div>
          </template>

          <template v-if="data.news_task.length">
            <p>浏览并关注热门主题，激发烹饪灵感！<br>关注越多，「名厨力」增长越快。</p>
            <div class="article_content">
              <div class="article_list">
                <div v-for="item in data.news_task" :key="item.id" class="list_item" @click="goSubject(item.des, item.skuid, item.title)">
                  <van-image class="article_pic" radius="2px" fit="cover" lazy-load :src="item.coverpic">
                    <span class="follow_type">{{ item.status ? '已关注' : '未关注' }}</span>
                  </van-image>
                  <p class="article_text fw_bold text_overflow2">{{ item.title }}</p>
                </div>
              </div>
            </div>
          </template>

          <p>继续完成每日任务，获得「名厨力」与积分奖励</p>
          <div class="three_task">
            <div v-for="task in data.day_task" :key="task.id" class="step_item">
              <div class="step_text">
                <p class="fw_bold">{{ task.task_name }}</p>
                <span>{{ task.over_num }}</span>
              </div>
              <span v-if="task.over_status == 1" class="step_btn step_finished fw_bold">已完成</span>
              <span v-else class="step_btn fw_bold" @click="goApp(task.des)">去完成</span>
            </div>
          </div>
          <div class="check_more">
            <span @click="goApp('integralcenter')">查看更多挑战任务</span>
          </div>
        </div>
      </div>
    </div>
    <div class="trial trial1">
      <img src="https://static.mingchu.co/webapp/xintan/title_bg3.png" class="title_bg">
      <van-image class="trial_banner" radius="2px" lazy-load src="https://static.mingchu.co/webapp/xintan/trial.jpg" @click="goApps()" />
      <p class="des_text">完成每日任务，当「名厨力」超过200分，即可参与试用挑战</p>
    </div>

  </div>
  <ShareBtn
    :show="showShare"
    @onSelect="onSelect"
    @onCancel="shareCancel"
  />

</template>
<script setup>
import { defineProps, watchEffect, ref, defineEmits } from 'vue'
import { Image as VanImage, Field as vanField, Toast } from 'vant'
import { superLink, shareWechat, goAppPage } from '@/utils'
import { post } from '@/api/ajax'
import config from '@/config/config.js'
import ShareBtn from '@/components/ShareBtn.vue'

const data = ref({}) // 元数据
const questionVal = ref('')
const isActiveEnd = ref(false) // 活动结束状态
const showShare = ref(false)

const emits = defineEmits(['onTrial'])
const props = defineProps({
  dataInfo: {
    type: Object,
    default: () => {}
  },
  shareInfo: {
    type: Object,
    default: () => {}
  }
})

watchEffect(() => {
  console.log('taskWatchEffect-share', props.shareInfo)
  isActiveEnd.value = props.dataInfo.server_time >= props.dataInfo.end_time
  data.value = props.dataInfo
})

const goApps = () => {
  emits('onTrial', true)
}

const setShareShow = () => {
  showShare.value = true
}

const shareCancel = () => {
  showShare.value = false
}

const onSelect = (item) => {
  if (isActiveEnd.value) { Toast('活动已结束'); return false }
  console.log('share_link', props.shareInfo.share_link)
  shareWechat(`{
          "shareSDKPlatformType":"${item === 'wechat' ? 22 : 23}", 
          "share_plant":"1", 
          "shareContentType":"0", 
          "share_miniProgram_url":"", 
          "share_title":"${props.shareInfo.share_title}",
          "share_desc":"${props.shareInfo.share_desc}",
          "share_img": "${props.shareInfo.share_img}", 
          "share_link": "${props.shareInfo.share_link}",  
          "share_desc_Sinaweibo":""
          }`).then(res => {
    shareCancel()
    markShare()
  })
}

const markShare = async() => { // 分享结束，通知后端
  const res = await post('/api/explore/share')
  console.log('share_success', res)
}

const goApp = (_des, _id = '') => {
  const param = `{
          "des": "${_des}",
          "skuid": "${_id}"
        }`
  goAppPage(param)
}

const nextQuestion = async(_type) => {
  if (_type === 'next' && data.value.ask_task.skip_total >= 3) {
    return Toast('已无法跳过问题')
  }
  if (_type !== 'next' && !questionVal.value.trim()) {
    return Toast('回答内容不能为空')
  }
  Toast.loading({
    message: 'Loading...',
    forbidClick: true
  })
  const param = {
    type: _type === 'next' ? 2 : 1,
    id: data.value.ask_task.id,
    content: questionVal.value
  }
  const res = await post('/api/explore/ask', param)
  if (res.code === 1) {
    data.value.ask_task = res.data
  }
  Toast.clear()
  Toast(res.message)
  questionVal.value = ''
}

const goSubject = (_des, _skuid, _title) => {
  const data = `{
          "des": "${_des}",
          "skuid": "${_skuid}",
          "link": "${_title}"
        }`
  return superLink(data)
}

const goPath = (_des, _skuid) => {
  const data = `{
          "des": "${_des}",
          "skuid": "${_skuid}",
          "link": "${config.webapplink}/${_des}?id=${_skuid}"
        }`
  return superLink(data)
}

</script>
